import type { OrderDetail, OrderProblem } from "../../services/use-orders"

export function orderAttention(data: Pick<OrderDetail, "resolution" | "problems">) {
  if (data.resolution.resolvedAt) {
    return { label: "Resolved", kind: "good" } as const
  }
  if (data.problems.length === 0) {
    return { label: "Systems agree", kind: "good" } as const
  }
  return {
    label: "Needs action",
    kind: data.problems.some((problem) => problem.severity === "critical") ? "bad" : "warn",
  } as const
}

export function journeyFlag(data: Pick<OrderDetail, "resolution" | "problems">, system: string) {
  if (data.resolution.resolvedAt) {
    return null
  }
  const flags = data.problems.flatMap((problem) => {
    const label = problemFlag(problem, system)
    return label
      ? [{ label, kind: problem.severity === "critical" ? ("bad" as const) : ("warn" as const) }]
      : []
  })
  return flags.find((flag) => flag.kind === "bad") ?? flags[0] ?? null
}

function problemFlag(problem: OrderProblem, system: string): string | null {
  if (problem.code === "shipment_suspended") {
    const suspended = ["magento", "oms"].includes(system) && problem.systems.includes(system)
    return suspended ? "Suspended" : null
  }
  const flags = {
    shipped_not_fulfilled: { system: "oms", label: "Not dispatched" },
    marketplace_behind: { system: "marketplace", label: "Behind" },
    oms_missing: { system: "oms", label: "Missing" },
    magento_unresolved: { system: "magento", label: "Needs a choice" },
    magento_push_stuck: { system: "magento", label: "Push stuck" },
    cancel_mismatch: null,
    stage_divergence: null,
  }
  const flag = flags[problem.code]
  return flag?.system === system ? flag.label : null
}

export function safeOrderUrl(candidate: string | null): string | null {
  if (!candidate) {
    return null
  }
  try {
    const url = new URL(candidate)
    return ["http:", "https:"].includes(url.protocol) ? url.toString() : null
  } catch {
    return null
  }
}

export function preferredTrackingUrl(data: OrderDetail) {
  return safeOrderUrl(data.marketplaceTracking?.trackingUrl ?? data.oms.trackingUrl)
}
